.input-wrapper {
  position: relative;

  // min-height: calc(var(--spacing-sm) * 2 + map-get($font-sizes, md) * 1.5 + 1.5rem);

  .form-error-message {
    display: none;
    min-height: 1.5rem;

    &.error-visible {
      display: block;
    }
  }

  .error-visible {
    visibility: visible;
    opacity: 1;
  }

  .error-hidden {
    visibility: hidden;
    opacity: 0;
  }
}

.input {
  display: inline-block;
  width: 100%;
  padding: var(--spacing-sm);
  font-family: inherit;
  font-size: map-get($font-sizes, md);
  line-height: 150%;
  color: var(--text-color-primary);
  border: var(--border-size-sm) solid var(--border-color-primary);
  background-color: var(--color-neutral-white);
  border-radius: var(--radius-size-md);
  transition: all 0.2s ease-in-out;

  &::placeholder {
    color: var(--text-color-tertiary);
  }

  &:hover {
    box-shadow: 0 0 0 1px rgb(0 0 0 / 100%);
  }

  &:focus {
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
    outline: none;
  }

  &:hover:focus {
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
  }
}

.input__label {
  display: inline-flex;
  padding-bottom: var(--spacing-sm);
}

.input--error {
  border-color: var(--color-system-error);

  // Use red outline on hover to maintain visual consistency with error state
  &:hover {
    box-shadow: 0 0 0 1px var(--color-system-error);
  }

  // Use red double shadow on focus, similar to normal focus but with error color
  &:focus {
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-system-error);
  }

  &:hover:focus {
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-system-error);
  }
}

.input--disabled {
  pointer-events: none;
  background-color: var(--color-neutral-neutral-lightest);
  border: var(--border-size-sm) solid var(--border-color-secondary);
  cursor: not-allowed;

  &::placeholder {
    color: var(--text-color-secondary);
  }
}

.input--filled-lock {
  pointer-events: none;
  background-color: var(--color-neutral-neutral-lightest);
  border: var(--border-size-sm) solid var(--border-color-secondary);
  color: var(--text-color-primary);
  cursor: not-allowed;
}
